var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 76,
    viewBox: "0 0 121 76",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#747D84",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.5 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.865 31.48c2.868 0 5.464 1.162 7.343 3.041a10.353 10.353 0 0 1 3.042 7.344V47c0 1.45-.588 2.762-1.538 3.712A5.234 5.234 0 0 1 35 52.25H4a5.234 5.234 0 0 1-3.712-1.538A5.234 5.234 0 0 1-1.25 47v-5.135c0-2.868 1.162-5.464 3.042-7.344a10.353 10.353 0 0 1 7.343-3.041z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5,
    cy: 13.351,
    rx: 11.982,
    ry: 12.101
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.865 31.48c2.868 0 5.464 1.162 7.343 3.041a10.353 10.353 0 0 1 3.042 7.344V47c0 1.45-.588 2.762-1.538 3.712A5.234 5.234 0 0 1 35 52.25H4a5.234 5.234 0 0 1-3.712-1.538A5.234 5.234 0 0 1-1.25 47v-5.135c0-2.868 1.162-5.464 3.042-7.344a10.353 10.353 0 0 1 7.343-3.041z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5,
    cy: 13.351,
    rx: 11.982,
    ry: 12.101
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 45.75c3.935 0 7.498 1.595 10.076 4.174A14.205 14.205 0 0 1 57.25 60v9c0 1.45-.588 2.762-1.538 3.712A5.234 5.234 0 0 1 52 74.25H4a5.234 5.234 0 0 1-3.712-1.538A5.234 5.234 0 0 1-1.25 69v-9c0-3.935 1.595-7.498 4.174-10.076A14.205 14.205 0 0 1 13 45.75z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 19,
    r: 17.75
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.396893deedef94c201421125023abb82.svg";
export { ForwardRef as ReactComponent };